import React from 'react';

import FinalFormInput from '@zola/zola-ui/src/components/Form/inputV3/FinalFormInput';
import { formatPhoneNumberUS } from '@zola/zola-ui/src/components/Form/util/formatPhoneNumber';
import { PHONE_US } from '@zola/zola-ui/src/components/Form/util/validations';

import styles from './phoneNumberField.module.less';

export const HELPER_TEXT = 'This will only be used by the vendor to contact you';
export const PhoneNumberField = ({
  showLabel = true,
  legend,
}: {
  showLabel?: boolean;
  legend?: string | JSX.Element;
}) => {
  const legendToShow = legend || 'Phone number';

  return (
    <fieldset className={styles.phoneNumberField}>
      {showLabel && <legend>{legendToShow}</legend>}
      <FinalFormInput
        name="phone"
        id="phone"
        type="tel"
        helperText={HELPER_TEXT}
        parse={formatPhoneNumberUS}
        validate={[PHONE_US]}
      />
    </fieldset>
  );
};
